<template lang="pug">
BriqDialog(
  @close="$emit('close')"
  dialogSize="briq-dialog-medium"
  )
  h2.h1.mb-S.text-center Before you save this...
  p Some fields which you provided value for, are not translated to every language.
  p The following fields remained empty:
  .warning-modal-field-list
    ul(
      v-for="(missingFields, languageCode) in fields"
      )
      li {{getDisplayName(languageCode)}}
      li.sub-list
        ul
          li(
            v-for="field in missingFields"
          ) {{field}}
  p(v-if="incompleteTranslations")
    .bold Some of your changes will not be saved:
    ul
      li(v-if="unTranslatedThemes") All your themes need to be translated for a specific language before they can be saved for that language.
      li(v-if="unTranslatedFilters") Every mandatory field of your custom filters need to be translated for a specific language before they can be saved for that language.
  .button-bar.button-bar--center
    BriqButton.warning-modal__edit-button(variant="secondary" ref="modalCancel" @click="$emit('close')" data-test-id="continue-editing-button") Continue editing
    BriqSubmitButton(
      @click="modalSubmit"
      ref="modalSubmit"
      data-test-id="save-anyway-button"
      ) Save anyway

</template>

<script>
import { emptyTranslatableFields } from '@v/util/emptyTranslatableFields.js'

export default {
  name: 'BriqMultilanguageWarningModal',
  props: {
    defaultModel: Object,
    translationInfo: Object,
    translatableProperties: Array,
  },
  computed: {
    fields() {
      return emptyTranslatableFields(
        this.defaultModel,
        this.translationInfo,
        this.translatableProperties,
      )
    },
    unTranslatedThemes() {
      let exists = false
      Object.keys(this.fields).forEach(key => {
        if (this.fields[key].includes('Filter - Occasions')) {
          exists = true
        }
      })
      return exists
    },
    unTranslatedFilters() {
      let exists = false
      Object.keys(this.fields).forEach(key => {
        if (this.fields[key].includes('Custom Filters')) {
          exists = true
        }
      })
      return exists
    },
    incompleteTranslations() {
      return this.unTranslatedThemes || this.unTranslatedFilters
    },
  },
  methods: {
    getDisplayName(languageCode) {
      return this.translationInfo.AvailableCultures.find(culture => culture.Name === languageCode)
        .DisplayName
    },
    modalSubmit() {
      this.$emit('onSubmit')
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="stylus">
.warning-modal__edit-button
  margin-right 15px

.button-bar{
  margin-top 40px
}

.warning-modal-field-list
  max-height 400px
  overflow auto

.sub-list
  list-style none

ul
  margin-left 20px
</style>
